import { createApp } from 'vue';
import website from './config/website';
import axios from './axios';
import router from './router/';
import store from './store';
import i18n from './lang/';
import { language, messages } from './lang/';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import ElementPlus from 'element-plus';
import 'virtual:svg-icons-register'; // svg
import Avue from '@smallwei/avue';
import * as Sentry from "@sentry/vue";

import '@smallwei/avue/lib/index.css';
import 'element-plus/dist/index.css'; // 默认的主题色
import 'styles/common.scss';
import 'animate.css';

// import crudCommon from '@/mixins/crud.js'; // 有空再整理
import { getScreen } from './utils/util';
import { getToken } from '@/utils/auth';
import { Lang } from '@/lang/lang';
import './permission';
import error from './error';
import avueUeditor from 'avue-plugin-ueditor';
import compIcon from 'components/comp-icon/index.vue';
import compSvg from 'components/comp-svg/index.vue';
import compButton from 'components/comp-button/index.vue';
import CompIconButton from 'components/comp-icon-button/index.vue';
import selectInput from 'components/select-input/index.vue';
import basicContainer from 'components/basic-container/main.vue';
import basicCard from 'components/basic-card/index.vue';
import thirdRegister from './components/third-register/main.vue';

// 插件
import Confirm from '@/components/comp-dialog';
// import NfDesignBase from '@saber/nf-design-base-elp'; // 流程图很大的包暂时用不上
import flowDesign from './components/flow-design/main.vue';
import breadcrumb from '@/components/page-index/top/breadcrumb.vue';
import WebSocketComponent from 'components/web-socket/index';
import UserInfo from '@/components/comp-user-info/index.vue';
import App from './App.vue';
import dayjs from 'dayjs';
// 业务组件
import tenantPackage from './views/system/tenantpackage.vue';
import removeAriaHidden from './directives/removeAriaHidden';

// window.$crudCommon = crudCommon;
window.axios = axios;
const app = createApp(App);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}
if (import.meta.env.MODE !== 'development') {
  Sentry.init({
    app,
    dsn: "https://7c20b4719b8f419219308c8914a0f932@o4509042134089728.ingest.us.sentry.io/4509042135334912"
  });
}
app.component('basicContainer', basicContainer);
app.component('breadcrumb', breadcrumb);
app.component('basicCard', basicCard);
app.component('compIcon', compIcon);
app.component('compSvg', compSvg);
app.component('compButton', compButton);
app.component('CompIconButton', CompIconButton);
app.component('selectInput', selectInput);
app.component('thirdRegister', thirdRegister);
app.component('flowDesign', flowDesign);
app.component('tenantPackage', tenantPackage);
app.component('WebSocketComponent', WebSocketComponent);
app.component('UserInfo', UserInfo);
app.config.globalProperties.$dayjs = dayjs;
app.config.globalProperties.website = website;
app.config.globalProperties.getScreen = getScreen;
app.config.globalProperties.Lang = Lang; // 全局挂载语言翻译
app.use(Confirm)
app.use(error);
app.use(i18n);
app.use(store);
async function initAfterGetAsyncRouter(params) {
  const token = getToken();
  if (token) { // 如果有token 处理复制页面链接打开找不到路由的情况
    try {
      const list = await store.dispatch('GetTopMenuAll');
      router.$avueRouter.formatRoutes(list, true);
    } catch (e) {
      store.dispatch('FedLogOut');
    }
  }
  app.use(router);
  // 注册全局指令
  app.directive('removeAriaHidden', removeAriaHidden);
  app.use(ElementPlus, {
    locale: messages[language],
  });
  app.use(Avue, {
    axios,
    calcHeight: 10,
    locale: messages[language],
  });
  app.use(avueUeditor, { axios })
  // app.use(NfDesignBase);
  app.mount('#app');
}
initAfterGetAsyncRouter();
